import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import api, { inr } from "@/lib/api";
import { Clock, Check } from "lucide-react";

const staticServices = [
  // Relaxing Massages
  {
    slug: "service-red",
    name: "Service Red",
    category: "massage",
    duration_min: 45,
    price: 1500,
    description:
      "A deeply relaxing experience crafted to release stress and elevate your senses, blending soothing massage techniques with a refreshing cleanse for complete comfort and satisfaction.",
    highlights: [
      "30 Minutes Relaxing Massage & Happy Ending with Cream || Hot Oil || Cold Oil",
      "15 Minutes Hot Shower || Cold Shower",
      "Duration of Service: 45 Minutes For only ₹1500/-",
    ],
    image: "/services/SERVICE-RED-HAMMAM.png",
  },
  {
    slug: "service-green",
    name: "Service Green",
    category: "massage",
    duration_min: 60,
    price: 2000,
    description:
      "An extended relaxation ritual designed to melt away tension while offering a richer, more indulgent massage experience, followed by a refreshing shower to leave you fully relaxed.",
    highlights: [
      "45 Minutes Relaxing Massage & Happy Ending with Cream || Hot Oil || Cold Oil",
      "15 Minutes Hot Shower || Cold Shower",
      "Duration of Service: 60 Minutes For Only: ₹2000/-",
    ],
    image: "/services/SERVICE-GREEN-HAMMAM.png",
  },
  {
    slug: "service-yellow",
    name: "Service Yellow",
    category: "massage",
    duration_min: 90,
    price: 2500,
    description:
      "Our most indulgent experience, combining deep relaxation with complete spa access. Designed for those who want more time, and a truly elevated Hammam experience.",
    highlights: [
      "45 Minutes Relaxing Massage & Happy Ending with Cream || Hot Oil || Cold Oil",
      "45 Minutes of Steam & Sauna Bath || Common Shower Area || Lockers || Dark Room || Jacuzzi. Total Duration: 90 Minutes For Only: ₹2500/-",
    ],
    image: "/services/Service-Yellow.png",
  },
  {
    slug: "service-rainbow",
    name: "Service Rainbow",
    category: "massage",
    duration_min: 90,
    price: 3000,
    description:
      "Our ultimate wellness ritual combining deep tissue work and active relaxation for total body harmony.",
    highlights: [
      "75 Minutes Relaxing Massage & Happy Ending with Cream || Hot Oil || Cold Oil",
      "15 Minutes Hot Shower || Cold Shower",
      "Duration of Service: 90 Minutes For Only: ₹3000/-",
    ],
    image: "/services/SERVICE-RAINBOW.png",
  },
  // Body Care Treatments
  {
    slug: "body-polishing",
    name: "Body Polishing",
    category: "body_care",
    duration_min: 60,
    price: 1500,
    description:
      "A gentle full-body treatment that helps your skin breathe again. It removes dull, dead skin and leaves your body feeling smooth, fresh, and naturally glowing — perfect if you want to look and feel renewed.",
    highlights: [
      "Full Body Exfoliation & Polishing Removes Dead Skin || Smooth & Soft Skin || Healthy Natural Glow Deep Cleansing || Nourishing Finish",
      "For Only: ₹1500/-",
    ],
    image: "/services/BODY-POLISHING.png",
  },
  {
    slug: "veet-waxing",
    name: "Veet/Waxing",
    category: "body_care",
    duration_min: 45,
    price: 1500,
    description:
      "A clean and smooth body-care service for those who like to feel fresh, confident, and well-groomed. Gentle on the skin and done with care, leaving your body smooth and comfortable.",
    highlights: [
      "Veet or Waxing (As Preferred)",
      "Clean & Smooth Skin || Hygienic Process || Comfortable Finish",
      "Suitable for Full Body Grooming For Only: ₹1500/-",
    ],
    image: "/services/VEET-WAXING.png",
  },
  {
    slug: "trimming",
    name: "Trimming",
    category: "body_care",
    duration_min: 30,
    price: 700,
    description:
      "A quick and neat grooming service for a clean, well-shaped look without irritation. Perfect for regular maintenance and a fresh, confident feel.",
    highlights: [
      "Safe & Hygienic Trimming",
      "Clean Finish || Comfortable Experience || Skin-Friendly",
      "Ideal for Body Grooming",
      "For Only: ₹700/-",
    ],
    image: "/services/TRIMMER.png",
  },
];

const getServiceTheme = (slug) => {
  if (slug === "service-red") {
    return {
      border: "border border-red-500 shadow-lg shadow-red-950/30",
      title:
        "text-transparent bg-clip-text bg-gradient-to-r from-red-500 via-rose-400 to-amber-300",
      check: "text-red-400",
      priceBg: "bg-red-950/50 text-red-400 border border-red-500/50",
      btn: "bg-gradient-to-r from-red-600 to-rose-600 hover:from-red-500 hover:to-rose-500 text-white rounded-xl font-extrabold uppercase text-xs px-8 py-3.5 shadow-lg shadow-red-950/50 hover:scale-105 transition-all tracking-wider",
      badgeBg: "bg-red-600 text-white font-extrabold border-red-500",
      badgeText: "HOT THERAPY",
    };
  }
  if (slug === "service-green") {
    return {
      border: "border border-emerald-400 shadow-lg shadow-emerald-950/30",
      title:
        "text-transparent bg-clip-text bg-gradient-to-r from-emerald-400 via-teal-300 to-amber-300",
      check: "text-emerald-400",
      priceBg:
        "bg-emerald-950/50 text-emerald-400 border border-emerald-500/50",
      btn: "bg-gradient-to-r from-emerald-600 to-teal-600 hover:from-emerald-500 hover:to-teal-500 text-white rounded-xl font-extrabold uppercase text-xs px-8 py-3.5 shadow-lg shadow-emerald-950/50 hover:scale-105 transition-all tracking-wider",
      badgeBg: "bg-emerald-600 text-white font-extrabold border-emerald-500",
      badgeText: "REJUVENATING",
    };
  }
  if (slug === "service-yellow") {
    return {
      border: "border border-amber-400 shadow-lg shadow-amber-950/30",
      title:
        "text-transparent bg-clip-text bg-gradient-to-r from-amber-300 via-hgold to-emerald-400",
      check: "text-amber-400",
      priceBg: "bg-amber-950/50 text-amber-300 border border-amber-500/50",
      btn: "bg-gradient-to-r from-amber-500 via-hgold to-yellow-500 hover:from-amber-400 hover:to-yellow-400 text-black font-extrabold uppercase text-xs px-8 py-3.5 rounded-xl shadow-lg shadow-amber-950/50 hover:scale-105 transition-all tracking-wider",
      badgeBg: "bg-amber-500 text-black font-extrabold border-amber-400",
      badgeText: "MOST POPULAR",
    };
  }
  if (slug === "service-rainbow") {
    return {
      border: "border border-purple-500 shadow-lg shadow-purple-950/30",
      title:
        "text-transparent bg-clip-text bg-gradient-to-r from-purple-400 via-pink-400 to-amber-300",
      check: "text-purple-400",
      priceBg: "bg-purple-950/50 text-purple-400 border border-purple-500/50",
      btn: "bg-gradient-to-r from-purple-600 via-pink-600 to-rose-600 hover:from-purple-500 hover:to-rose-500 text-white rounded-xl font-extrabold uppercase text-xs px-8 py-3.5 shadow-lg shadow-purple-950/50 hover:scale-105 transition-all tracking-wider",
      badgeBg: "bg-purple-600 text-white font-extrabold border-purple-500",
      badgeText: "RAINBOW SPECIAL",
    };
  }
  if (slug === "body-polishing") {
    return {
      border: "border border-rose-400 shadow-lg shadow-rose-950/30",
      title:
        "text-transparent bg-clip-text bg-gradient-to-r from-rose-400 via-pink-300 to-amber-300",
      check: "text-rose-400",
      priceBg: "bg-rose-950/50 text-rose-300 border border-rose-500/50",
      btn: "bg-gradient-to-r from-rose-600 to-pink-600 hover:from-rose-500 hover:to-pink-500 text-white rounded-xl font-extrabold uppercase text-xs px-8 py-3.5 shadow-lg shadow-rose-950/50 hover:scale-105 transition-all tracking-wider",
      badgeBg: "bg-rose-600 text-white font-extrabold border-rose-500",
      badgeText: "GLOW & CARE",
    };
  }
  if (slug === "veet-waxing") {
    return {
      border: "border border-cyan-400 shadow-lg shadow-cyan-950/30",
      title:
        "text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 via-teal-300 to-emerald-400",
      check: "text-cyan-400",
      priceBg: "bg-cyan-950/50 text-cyan-300 border border-cyan-500/50",
      btn: "bg-gradient-to-r from-cyan-600 to-teal-600 hover:from-cyan-500 hover:to-teal-500 text-white rounded-xl font-extrabold uppercase text-xs px-8 py-3.5 shadow-lg shadow-cyan-950/50 hover:scale-105 transition-all tracking-wider",
      badgeBg: "bg-cyan-600 text-white font-extrabold border-cyan-500",
      badgeText: "SMOOTH CARE",
    };
  }
  if (slug === "trimming") {
    return {
      border: "border border-teal-400 shadow-lg shadow-teal-950/30",
      title:
        "text-transparent bg-clip-text bg-gradient-to-r from-teal-400 via-emerald-300 to-hgold",
      check: "text-teal-400",
      priceBg: "bg-teal-950/50 text-teal-300 border border-teal-500/50",
      btn: "bg-gradient-to-r from-teal-600 to-emerald-600 hover:from-teal-500 hover:to-emerald-500 text-white rounded-xl font-extrabold uppercase text-xs px-8 py-3.5 shadow-lg shadow-teal-950/50 hover:scale-105 transition-all tracking-wider",
      badgeBg: "bg-teal-600 text-white font-extrabold border-teal-500",
      badgeText: "QUICK GROOM",
    };
  }
  return {
    border: "border border-hgold shadow-lg shadow-yellow-950/30",
    title: "text-hgold",
    check: "text-hgold",
    priceBg: "bg-hgold/20 text-hgold border border-hgold/40",
    btn: "gold-btn rounded-xl px-8 py-3.5",
    badgeBg: "bg-hgold text-black font-extrabold border-hgold",
    badgeText: "PREMIUM",
  };
};

export default function Services() {
  const [list, setList] = useState([]);
  const [activeCategory, setActiveCategory] = useState("massage");

  useEffect(() => {
    api
      .get("/services")
      .then((r) => setList(r.data))
      .catch(() => {});
  }, []);

  const categories = [
    { id: "massage", label: "Relaxing Massages" },
    { id: "body_care", label: "Body Care Treatments" },
  ];

  const getDbServiceId = (slug) => {
    const found = list.find((item) => item.slug === slug);
    return found ? found.id : "";
  };

  const filteredServices = staticServices.filter(
    (s) => s.category === activeCategory,
  );

  return (
    <div data-testid="services-page">
      {/* Hero Header */}
      <section className="relative min-h-[50vh] overflow-hidden -mt-[72px] flex items-center">
        <img
          src="/hero_image_hammam.png"
          alt="Services"
          className="absolute inset-0 w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black via-black/85 to-black/40" />
        <motion.div
          initial={{ opacity: 0, y: 50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1.0, ease: [0.25, 1, 0.5, 1] }}
          className="relative max-w-7xl mx-auto px-6 lg:px-10 pt-40 pb-20 w-full"
        >
          <div className="label-eyebrow mb-6 text-emerald-400 font-extrabold tracking-widest uppercase">
            Best Gay Spa in New Delhi
          </div>
          <h1 className="text-5xl lg:text-7xl font-heading text-transparent bg-clip-text bg-gradient-to-r from-white via-amber-200 to-emerald-400 mb-6">
            Services At Hammam
          </h1>
          <p className="text-hsecondary text-lg max-w-2xl mt-4 leading-relaxed font-normal">
            Discover our curated range of therapies, body care rituals, and
            grooming treatments.
          </p>
        </motion.div>
      </section>

      {/* Tabs Menu */}
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-12">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.9, ease: [0.25, 1, 0.5, 1] }}
          className="flex flex-wrap gap-5 justify-center mb-16"
        >
          {categories.map((cat) => {
            const isActive = activeCategory === cat.id;
            let activeStyle = "";
            if (isActive) {
              activeStyle =
                cat.id === "massage"
                  ? "bg-gradient-to-r from-amber-500 via-hgold to-yellow-500 text-black font-extrabold border border-amber-400 shadow-xl shadow-amber-500/25 scale-105"
                  : "bg-gradient-to-r from-emerald-500 via-teal-500 to-emerald-600 text-white font-extrabold border border-emerald-400 shadow-xl shadow-emerald-500/25 scale-105";
            } else {
              activeStyle =
                "bg-hpaper border border-white/15 text-white/80 hover:border-hgold/70 hover:text-white";
            }
            return (
              <button
                key={cat.id}
                onClick={() => setActiveCategory(cat.id)}
                className={`px-9 py-4 rounded-full font-heading text-sm sm:text-base tracking-wide transition-all duration-300 ${activeStyle}`}
              >
                {cat.label}
              </button>
            );
          })}
        </motion.div>

        {/* Services List Layout */}
        <div className="space-y-10">
          {filteredServices.map((s, idx) => {
            const theme = getServiceTheme(s.slug);
            return (
              <motion.div
                key={s.slug}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, ease: [0.25, 1, 0.5, 1] }}
                className={`bg-gradient-to-r from-hpaper via-black/90 to-hpaper rounded-2xl overflow-hidden flex flex-col md:flex-row ${theme.border} transition-all duration-300 group`}
              >
                {/* Left Side: Full Uncropped Image */}
                <div className="w-full md:w-[280px] lg:w-[320px] shrink-0 overflow-hidden relative border-b md:border-b-0 md:border-r border-white/10 flex items-center justify-center bg-black/40">
                  <img
                    src={s.image}
                    alt={s.name}
                    className="w-full h-auto block object-contain group-hover:scale-105 transition-transform duration-700"
                  />
                  <div
                    className={`absolute top-3 left-3 border px-3 py-1 rounded-full text-[10px] font-extrabold tracking-widest uppercase backdrop-blur-md ${theme.badgeBg}`}
                  >
                    {theme.badgeText}
                  </div>
                </div>

                {/* Right Side: Compact Details matching Image Height */}
                <div className="p-6 lg:p-8 flex-1 flex flex-col justify-between self-stretch">
                  <div>
                    <div className="flex flex-wrap items-center justify-between gap-3 mb-3">
                      <h3
                        className={`font-heading text-2xl sm:text-3xl font-bold ${theme.title}`}
                      >
                        {s.name}
                      </h3>
                      <div
                        className={`px-3.5 py-1 rounded-full text-xs sm:text-sm font-bold font-heading ${theme.priceBg}`}
                      >
                        {inr(s.price)}
                      </div>
                    </div>
                    <p className="text-hsecondary text-xs sm:text-sm leading-relaxed mb-4 font-normal">
                      {s.description}
                    </p>

                    {/* Highlights */}
                    <div className="space-y-2 mb-5">
                      {s.highlights.map((highlight, index) => (
                        <div
                          key={index}
                          className="flex items-start gap-2.5 text-white/90 text-xs sm:text-sm leading-relaxed"
                        >
                          <Check
                            size={15}
                            className={`${theme.check} mt-0.5 shrink-0`}
                          />
                          <span>{highlight}</span>
                        </div>
                      ))}
                    </div>
                  </div>

                  {/* Buttons */}
                  <div className="flex flex-wrap gap-4 border-t border-white/10 pt-4 items-center justify-between">
                    <div className="flex items-center gap-2 text-[11px] text-white/60 uppercase tracking-widest font-semibold">
                      <Clock size={13} className="text-hgold" />{" "}
                      {s.duration_min} Mins Session
                    </div>
                    <Link
                      to={`/book?service_id=${getDbServiceId(s.slug)}`}
                      className={theme.btn}
                    >
                      Book Now
                    </Link>
                  </div>
                </div>
              </motion.div>
            );
          })}
        </div>
      </div>
    </div>
  );
}
